// This is just an example,
// so you can safely delete all default props below

export default {
    title: 'Account Delete Success',
    description: 'Your account has now been deleted. Valid tickets are still valid. You are welcome to create a new account again.'
}
